import {gsap, Power2} from "gsap";


export class Moon {
    constructor(card_id, card) {
        this.moon = document.querySelector(`#${card_id} .moon`);
        this.moon.style.bottom = -this.moon.clientHeight + 'px';
        this.card = card;
        this.card_id = card_id;
    }

    adjustPosition(weather_type, now, sunrise_dt, sunset_dt) {
        switch (weather_type) {
            case 'sun':
            case 'cloud':
                gsap.to(this.moon.style, {
                    duration: 0,
                    ease: Power2.easeInOut,
                    bottom: this.#computeClearPosition(now, sunrise_dt, sunset_dt) + 'px'
                });
                break;
            default:
                this.moon.style.bottom = -this.moon.clientHeight + 'px';
                break;
        }
    }

    #computeClearPosition(now, sunrise_dt, sunset_dt) {
        const sunriseTimestamp = sunrise_dt;
        const sunsetTimestamp = sunset_dt;
        const middlePosition = (this.card.height / 2 - this.moon.clientHeight / 2);
        const bottomPosition = -this.moon.clientHeight;
        let currentPosition;

        if (now < sunsetTimestamp && now > sunriseTimestamp) {
            currentPosition = bottomPosition;
        } else if (now > sunsetTimestamp + 60 * 60 || now < sunriseTimestamp - 60 * 60) {
            currentPosition = middlePosition;
        } else if (now > sunsetTimestamp + 30 * 60) {
            currentPosition = bottomPosition - (bottomPosition - middlePosition) * (now - sunsetTimestamp - 30 * 60) / 30 / 60;
        } else if (now > sunriseTimestamp - 30 * 60) {
            currentPosition = bottomPosition - (bottomPosition - middlePosition) * (sunriseTimestamp - now) / 30 / 60;
        } else {
            currentPosition = middlePosition;
        }
        return currentPosition;
    }

    /**
     *
     * @param phase - moon phase, 0 and 1 are new moon, 0.5 is full moon
     * @returns {*}
     */
    makeSVG(phase) {
        this.moon.querySelectorAll("defs > *").forEach(EL => EL.remove());
        let g = this.moon.querySelector("g");
        let defs = this.moon.querySelector('defs');
        g.setAttribute("filter", "url(#moon-inset-shadow)");
        if (phase === 0.5) {
            // do nothing
        } else if (phase <= 0.25 || phase >= 0.75) {
            // crescent waxing / waning (0 - 0.25, 0.75-1.0)
            // 0.25 -- cx amd r are large and more or less the same
            // 0 -- cx is 0 and r = 5
            let phasex;
            if (phase <= 0.25) {
                phasex = phase;
            } else {
                phasex = 1 - phase;
            }

            let cx = 18 * phasex / (1.01 - 4 * phasex);
            let r = cx + 6 / (Math.pow(cx, 1.25) / 6 + 6 / 5);
            let r_mask = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            r_mask.setAttribute("x", -5);
            r_mask.setAttribute("y", -5);
            r_mask.setAttribute("width", 10);
            r_mask.setAttribute("height", 10);
            r_mask.setAttribute("fill", "white");

            // Create a new circle
            let c_mask = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            c_mask.setAttribute("cx", cx);
            c_mask.setAttribute("cy", 0);
            c_mask.setAttribute("r", r);
            c_mask.setAttribute("fill", "black");
            c_mask.setAttribute("filter", "url(#moon-blur-filter)");

            // Create a new group and add the rectangle and circle to it
            let mask = document.createElementNS("http://www.w3.org/2000/svg", "mask");
            let g_mask = document.createElementNS("http://www.w3.org/2000/svg", "g");
            g_mask.appendChild(r_mask);
            g_mask.appendChild(c_mask);
            mask.setAttribute("id", "moon-mask-"+this.card_id);

            mask.appendChild(g_mask)
            defs.appendChild(mask);

            g.setAttribute("mask", `url(#${mask.id})`);

            if (phase <= 0.25) {
                // crescent waxing (right)
                g.setAttribute("transform", "rotate(-13) scale(-1,1)");
            } else {
                // crescent waning(left)
                g.setAttribute("transform", "rotate(-13)");
            }
        } else {
            // waxing gibbous (0.25 - 0.5)
            // 0.25 -- cx amd r are large and more or less the same
            // 0.5 -- cx is 0 and r = 5
            // invert the phase around 0.25
            let phasex;
            if (phase <= 0.5) {
                phasex = -phase + 0.5;
            } else {
                phasex = phase - 0.5;
            }
            let cx = 18 * phasex / (1.01 - 4 * phasex);
            let r = cx + 6 / (Math.pow(cx, 1.25) / 6 + 6 / 6);
            let c_mask = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            c_mask.setAttribute("cx", 0);
            c_mask.setAttribute("cy", 0);
            c_mask.setAttribute("r", 5);
            c_mask.setAttribute("fill", "black");

            let c_mask1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            c_mask1.setAttribute("cx", cx);
            c_mask1.setAttribute("cy", 0);
            c_mask1.setAttribute("r", r);
            c_mask1.setAttribute("fill", "white");
            c_mask1.setAttribute("filter", "url(#moon-blur-filter)");

            let mask = document.createElementNS("http://www.w3.org/2000/svg", "mask");
            let g_mask = document.createElementNS("http://www.w3.org/2000/svg", "g");
            g_mask.appendChild(c_mask);
            g_mask.appendChild(c_mask1);
            mask.setAttribute("id", "moon-mask-"+this.card_id);

            mask.appendChild(g_mask)
            defs.appendChild(mask);

            g.setAttribute("mask", `url(#${mask.id})`);
            if (phase <= 0.5) {
                // gibbous waxing (right)
                g.setAttribute("transform", "rotate(-13)");
            } else {
                // gibbous waning(left)
                g.setAttribute("transform", "rotate(-13) scale(-1,1)");
            }
        }

        // solve this:
        // f(6,8) = 0.375
        // f(20,21)= 0.25
        // f(2,6) = 0.45
        // f(0, 5) = 0.5
    }

}
